import camelCase from 'lodash/camelCase';
import { convertObject } from 'utils/convertObject';

export const convertSnakeToCamelCase = (param: any): any =>
  convertObject({
    mutator: camelCase,
    param,
  });
